import React from 'react';

import Icons from '../../components/Icons/Icons.js';
import css from './ListingRedesign.module.css';

/**
 * SectionReadyToRent — full-width dark CTA banner placed lower on the page
 * (Haul Star redesign). Captures intent AFTER the renter has read the details,
 * exactly when they are most likely to convert (strategy doc item H).
 *
 * Reuses the SAME handlers/tracking as the top contact card, so a tap here is
 * attributed identically (owner proof stats + Meta CAPI).
 *
 * @param {Function} onContact     Send Message / contact-owner handler
 * @param {String}   phoneNumber   raw phone (optional)
 * @param {String}   telLink       formatted tel: href (optional)
 * @param {Function} onCallClick   tracker for the call tap (optional)
 */
const SectionReadyToRent = ({ onContact, phoneNumber, telLink, onCallClick }) => {
  return (
    <div className={css.rdReadyBanner}>
      <h2 className={css.rdReadyTitle}>Ready to rent this trailer?</h2>
      <p className={css.rdReadySub}>
        Contact the owner directly. No BigLoads booking fees, no middleman. Get your questions
        answered and lock in your dates.
      </p>
      <div className={css.rdReadyBtns}>
        {telLink ? (
          <a
            className={`${css.rdReadyBtn} ${css.rdReadyBtnPrimary}`}
            href={telLink}
            onClick={onCallClick}
          >
            <Icons name="phoneFilled" /> Call Owner
          </a>
        ) : null}
        {typeof onContact === 'function' ? (
          <button
            type="button"
            className={`${css.rdReadyBtn} ${css.rdReadyBtnOutline}`}
            onClick={onContact}
          >
            <Icons name="message" /> Send Message
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default SectionReadyToRent;
